import { wrapPromise } from 'persist-promise/wrapPromise';
import { getDefinitionsFromObjectTypeRpc } from 'framework-data-schema-quick-fetch/associationDefinitions/mainClient';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { makeAssociationDefinitionsFetchKey } from 'framework-data-schema-quick-fetch/buildQuickFetchClientInstance';
const fetchAssociationDefinitions = ({
  rpcClient,
  frameworkTypeIdentifier
}) => rpcClient.call(getDefinitionsFromObjectTypeRpc, {
  request: {
    objectType: frameworkTypeIdentifier,
    definitionRequestOptions: {
      enforceStrictPermissions: true
    }
  }
}).then(data => data.associationDefinitions);
const associationDefinitionsPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'associationDefinitions',
  deepFreeze: true,
  // CHIRP manages quick-fetches internally, so we don't need to share the cache key
  toCacheKey: makeAssociationDefinitionsFetchKey,
  fetch: fetchAssociationDefinitions,
  metricsConfig: {
    convertKeyToMetricsDimension: key => {
      var _key$match$, _key$match;
      return (_key$match$ = (_key$match = key.match(makeAssociationDefinitionsFetchKey({
        frameworkTypeIdentifier: '(.*)'
      }))) === null || _key$match === void 0 ? void 0 : _key$match[1]) !== null && _key$match$ !== void 0 ? _key$match$ : null;
    },
    enablePatchDiffing: true,
    normalizeForPatchDiffing: defs => defs.slice().sort((a, b) =>
    // Association ids are only unique within their category. Luckily we only need a stable sort here.
    `${a.category.toString()}-${a.id}`.localeCompare(`${b.category.toString()}-${b.id}`))
  }
});
export const makeAssociationDefinitionsClient = ({
  rpcClient,
  persistedPromise = associationDefinitionsPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier
  }) => {
    Metrics.counter('associationDefinitions.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled()
    })({
      rpcClient,
      frameworkTypeIdentifier
    });
  }
});